import { Component, OnInit } from '@angular/core';
import { IAppraiser } from 'src/app/shared/classes/appraiser';
import { IUser } from 'src/app/shared/classes/user';
import { SystemService } from 'src/app/services/system.service';
import { DictionaryService } from 'src/app/services/dictionary.service';
import { MessageService, Message, ConfirmationService } from 'primeng/api';
import { CookieService } from 'ngx-cookie-service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import {Observable} from "rxjs";


@Component({
  templateUrl: './appraiser.component.html'
})
export class AppraiserComponent implements OnInit {

  appealsUserList: IUser[];
  allAppealsUsers: IUser[];
  appraiserList: IAppraiser[];
  myUser: IUser = {
    id: 0,
    emailAddress: '',
    firstName: '',
    lastName: '',
    userType: '',
    isActive: true,
    username: '',
    lastLoginDt: '',
  };
  userType: string;  // this is userType of logged on user for checking Read-Only
  userTypeList = [];
  userTypeListAssessor = ['Assessor', 'Assessor-Supervisor', 'Assessor-Manager', 'Assessor-ReadOnly'];
  userTypeListCoB = ['Administrator', 'Clerk of the Board', 'ReadOnly', 'Assessor-Manager'];
  userTypeListALL = ['Administrator', 'Clerk of the Board', 'ReadOnly','Assessor', 'Assessor-Supervisor', 'Assessor-Manager', 'Assessor-ReadOnly' ];

  isNewEntry = false;

  displayState: any = {
    workingDiv: false,
    userDiv: false,
    gridDiv: true,
    editUserDiv: false,
    saveDisabled: false
  };

  activeUserOnly = false;

  constructor(private systemService: SystemService, private messageService: MessageService,
              private confirmationService: ConfirmationService,
              private dictionaryService: DictionaryService, private utilService: UtilitiesService,
              private cookieService: CookieService) { }

  ngOnInit() {
    this.userTypeList = this.userTypeListAssessor; // default to ONLY Assessor-related types
    this.displayState.gridDiv = true;
    this.displayState.userDiv = false;
    this.displayState.editUserDiv = false;
    this.loadUserList();
    this.loadAppraiserList();
  }

  loadUserList() {
    this.displayState.workingDiv = true;
    this.systemService.getUserList().subscribe (data => {
      this.utilService.doAudit(data,'all users:');
      this.allAppealsUsers = [];
      this.allAppealsUsers = data;
      this.appealsUserList = [];
      this.filterOnStatus();
      this.filterForAppraisers();
      this.displayState.workingDiv = false;
    });
  }

  filterForAppraisers() {
    const userTypes = this.userTypeListAssessor;
    let appList = this.appealsUserList;
    // this.utilService.doAudit(appList, 'starting user list:');
    // this.utilService.doAudit(userTypes.indexOf(appList[0].userType), 'index:');
    appList = appList.filter(user => {
      return userTypes.indexOf(user.userType) > -1 ? user: null;
    });
    this.utilService.doAudit(appList, 'ending list:');
    this.appealsUserList = appList;
    this.displayState.workingDiv = false;
  }

  filterOnStatus() {
    // work from last downloaded list of ALL users so we don't have to make another call...
    const userTypes = this.userTypeListAssessor;
    const activeOnly = this.activeUserOnly;

    let appealsUserList = this.allAppealsUsers.filter(t => {
      let hit = (userTypes.indexOf(t.userType) > -1 && ( ( activeOnly === true && t.isActive == true) || (activeOnly === false)) ) ;
      return hit ? t : null;
    });
    this.appealsUserList = [];
    this.appealsUserList = appealsUserList;
  }
  onSelect(user: IUser) {
    // display the edit User form
    this.displayState.gridDiv = false;
    this.displayState.userDiv = true;
    this.isNewEntry = false;
    // set user data for display
    this.myUser.id = user.id;
    this.myUser.emailAddress = user.emailAddress;
    this.myUser.firstName = user.firstName;
    this.myUser.lastName = user.lastName;
    this.myUser.userType = user.userType;
    this.myUser.isActive = user.isActive;
    //
    this.displayState.editUserDiv = true;
    return true;
  }

  newUser() {
    this.displayState.gridDiv = false;
    this.displayState.userDiv = true;
    this.isNewEntry = true;
    this.displayState.editUserDiv = true;
    // set user data for display
    this.myUser.id = 0;
    this.myUser.emailAddress = '';
    this.myUser.firstName = '';
    this.myUser.lastName = '';
    this.myUser.userType = '';
    this.myUser.isActive = true;
    //
    return true;
  }

  saveUser() {
    // validate data...
    if (this.validateUserData() === false ) {
      return false;
    }
    this.displayState.saveDisabled = true;  // so they can't click on the Save button again...
    // save user data
    this.systemService.saveUser(this.myUser).subscribe (data => {
      // this.utilService.doAudit(data,'returned from saveUser:');
      if (data) {
        // update the Appraiser dictionary...
        this.saveAppraiser(this.myUser).subscribe(data2 => {
          // MUST subscribe in order for the service (http) to be run!!!
          // this.utilService.doAudit(data2, 'response from save appraiser:');
        });
      }
      // and hide the Edit window
      this.displayState.userDiv = false;
      this.displayState.editUserDiv = false;
      this.displayState.saveDisabled = false;
      // display grid div
      this.displayState.gridDiv = true;
      this.showToast({severity: 'success', summary: '', detail: 'User data updated.'});
      // refresh the grid/list
      this.loadUserList();
    });
    //
    return true;
  }
  loadAppraiserList() {
    this.displayState.workingDiv = true;
    this.appraiserList = [];
    this.dictionaryService.getAssessorList().subscribe (data => {
      this.utilService.doAudit(data,'load assessor list:');
      if (data) {
        this.appraiserList = data;
      }
      this.displayState.workingDiv = false;
    });
  }

  saveAppraiser(myUser: IUser): Observable<any> {
    const userName = myUser.lastName + ', ' + myUser.firstName;
    const appraiserId = this.findAppraiser(myUser, userName);
    this.utilService.doAudit(appraiserId, 'matching appraiser id:');
    let myAppraiser: IAppraiser = {
      id: appraiserId,
      isActive: myUser.isActive,
      name: userName,
      appealsUserId: myUser.id
    }
    return this.dictionaryService.saveAssessor(myAppraiser);
  }
  // locate a matching appraiser in the Appraiser table, based on appealsUserId and, optionally, on user name
  findAppraiser(myUser: IUser, userName: string): number {
    // this.utilService.doAudit(this.appraiserList, 'appraisers:');
    let appraiser;
    appraiser = this.appraiserList.filter(a => {
      let hit = a.appealsUserId == myUser.id;
      return hit ? a : null;
    });
    // this.utilService.doAudit(appraiser, 'lookup based on userId:');
    if (appraiser.length < 1) {
      // this.utilService.doAudit(userName, 'looking up name:');
      appraiser = this.appraiserList.filter(a => {
        let hit = (a.name.toLowerCase() == userName.toLowerCase());
        return hit ? a : null;
      });
      // this.utilService.doAudit(appraiser, 'lookup based on name:');
    }
    return appraiser.length > 0 ? appraiser[0].id : 0;
  }

  validateUserData() {
    // validate required user data; should we base it on value of any element w/ prd-required class??
    if ((this.myUser.emailAddress === '') || (this.myUser.lastName === '') || (this.myUser.userType === '')) {
      this.showToast({severity: 'error', summary: '', detail: 'Required items are missing.'});
      return false;
    } else if (this.myUser.emailAddress.indexOf('@') < 0) {
      this.showToast({severity: 'error', summary: '', detail: 'Email address MUST contain @.'});
      return false;
    } else if (this.isDuplicateUser(this.myUser)) {
      this.showToast({severity: 'error', summary: '', detail: 'Email already being used!'});
      return false;
    }
    return true;
  }

  // DEPRECATED - 7/31/2025
  validateUserDataOLD() {
    // validate required user data; base it on value of any element w/ prd-required class??
    if ((this.myUser.emailAddress === '') || (this.myUser.lastName === '') || (this.myUser.userType === '')) {
      return false;
    }
    return true;
  }

  isDuplicateUser(user) {
    // determine if duplicate user (i.e. one w/ same email address, but different id)
    // NOTE: check against ALL users (not just the appraisers!)
    let dupUser = this.allAppealsUsers.filter(t => {
      let hit = ( (t.emailAddress === user.emailAddress) && (t.id !== user.id) );
      return hit ? t : null;
    });
    // IFF we found at least one matching entry, then identify the current user as a duplicate!
    return dupUser.length > 0;
  }

  deleteUser(user: IUser) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this User?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.systemService.deleteUser(user).subscribe(data => {
          this.showToast({severity: 'success', detail: 'User has been DELETED.', summary: ''});
          this.loadUserList();
        });
      },
      reject: () => {
        this.showToast({severity: 'info', detail: 'No action performed.', summary: ''});
      }
    });

    return true;
  }

  cancelEntry() {
    this.displayState.userDiv = false;
    this.displayState.editUserDiv = false;
    this.displayState.gridDiv = true;
    return true;
  }

  showToast(msg: Message) {
    this.messageService.add(msg);
  }

  clear() {
    this.messageService.clear();
  }

}
